function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var recctr = function recctr(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 24.2935L1 7.70653L10.1389 1L20 1L29.8611 1L39 7.70653L39 24.2935L29.8611 31H20L10.1389 31L1 24.2935Z",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9H27V20H13V9Z",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20H30V23H10V20Z",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4897 39L14.1564 23H25.8436L23.5103 39H20H16.4897Z",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40L20 22",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 35L15.0001 35",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 27H15",
    stroke: "black",
    strokeWidth: "2"
  }));
};

export default recctr;